<template>
    <a :href="urlFactory.makeCompanyBookingFormUrl(company.slug)">
        <div class="inline-flex items-center gap-2">
            <template
                v-if="
                    company.defaultBookingFormTheme.showCompanyLogo &&
                    company.logoImage
                "
            >
                <Image
                    :src="company.logoImage.url"
                    class="max-w-32 max-h-10 min-h-10 object-contain"
                    loading="lazy"
                />
            </template>
            <span
                v-if="company.defaultBookingFormTheme.showCompanyDisplayName"
                class="font-medium text-sm md:text-base"
            >
                {{ company.displayName }}
            </span>
        </div>
    </a>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import type { PropType } from 'vue'
    import Company from '@/App/Company/Entity/Company'
    import Image from '@/Shared/Component/Image.vue'

    const props = defineProps({
        company: {
            type: Object as PropType<Company>,
            required: true,
        },
    })
    const urlFactory = new UrlFactory()
</script>
